<template>
  <div class="ccontainer">
    <div class="top">
      <img :src="commentItem.headImg" alt=""/>
      <div>
        <div class="name">{{ commentItem.name }}</div>
        <span class="date">{{floor+1}}楼 {{ commentItem.createTime }}</span>
      </div>
    </div>
    <div class="content">
      {{ commentItem.comment }}
    </div>
    <div class="otherCount">
      <div class="count">
        <span class="iconfont" v-if="createBy == commentItem.valuator"
        >&#xe61a; {{ commentItem.commentCount }}</span
        >
        <span @click="addCommentPraise(1)">
          <div v-if="0 < commentItem.isSupport" style="display: inline-block;">
            <img
              src="../assets/icons/dianzanred.png"
              style="width: 11px; height: 11px;min-width:100%; min-height: 100%;"
            />
          </div>
          <div v-if="1 > commentItem.isSupport" style="display: inline-block;">
            <img
              src="../assets/icons/zanblack.png"
              style="width: 11px; height: 11px;min-width:100%; min-height: 100%;"
            />
          </div>
          <span style="margin: 3px">{{ commentItem.support }}</span>
        </span>
        <span @click="addCommentPraise(2)">
          <div v-if="0 < commentItem.unSupport" style="display: inline-block;">
            <img
              src="../assets/icons/dianzanred.png"
              style="width: 11px; height: 11px;min-width:100%; min-height: 100%;transform:rotate(180deg)"
            />
          </div>
          <div v-if="1 > commentItem.unSupport" style="display: inline-block;">
            <img
              src="../assets/icons/zanblack.png"
              style="width: 11px; height: 11px;min-width:100%; min-height: 100%;transform:rotate(180deg)"
            />
          </div>
          <span style="margin: 3px">{{ commentItem.unSupport }}</span>
        </span>
      </div>
      <!--            <div>-->
      <!--                <span class="iconfont">&#xe661;</span>-->
      <!--                <span style="margin-left:5px">举报</span>-->
      <!--            </div>-->
    </div>
    <div class="otherComment" v-if="null != commentItem.reComment">
      <div class="top">
        <img :src="commentItem.reComment.headImg" alt=""/>
        <div>
          <div class="name">{{ commentItem.reComment.name }}</div>
          <span class="date">{{ commentItem.reComment.createTime }}</span>
        </div>
      </div>
      <div class="content">
        {{ commentItem.reComment.comment }}
      </div>
      <div class="otherCount">
        <div class="count">
          <span @click="addCommentPraise(3)">
            <div
              v-if="0 < commentItem.reComment.isSupport"
              style="display: inline-block;"
            >
              <img
                src="../assets/icons/dianzanred.png"
                style="width: 11px; height: 11px;min-width:100%; min-height: 100%;"
              />
            </div>
            <div
              v-if="1 > commentItem.reComment.isSupport"
              style="display: inline-block;"
            >
              <img
                src="../assets/icons/zanblack.png"
                style="width: 11px; height: 11px;min-width:100%; min-height: 100%;"
              />
            </div>
            <span style="margin: 3px">{{ commentItem.reComment.support }}</span>
          </span>
          <div class="ccontainer">
            <div class="top">
              <img :src="commentItem.headImg" alt="">
              <div>
                <div class="name">{{ commentItem.name }}</div>
                <span class="date">{{ floor + 1 }}楼 {{ commentItem.createTime }}</span>
                <!--                <span class="date">{{ commentItem.createTime }}</span>-->
              </div>
            </div>
            <div class="content">
              {{ commentItem.comment }}
            </div>
            <div class="otherCount">
              <div class="count">
                <span class="iconfont" v-if="createBy==commentItem.valuator">&#xe61a; {{
                    commentItem.commentCount
                  }}</span>
                <span @click="addCommentPraise(1)">
                      <div v-if="0 < commentItem.isSupport" style="display: inline-block;">
                        <img src="../assets/icons/dianzanred.png"
                             style="width: 11px; height: 11px;min-width:100%; min-height: 100%;"/>
                      </div>
                      <div v-if="1>commentItem.isSupport" style="display: inline-block;">
                        <img src="../assets/icons/zanblack.png"
                             style="width: 11px; height: 11px;min-width:100%; min-height: 100%;"/>
                      </div>
                      <span style="margin: 3px">{{ commentItem.support }}</span>
                    </span>
                <span @click="addCommentPraise(2)">
                      <div v-if="0 < commentItem.unSupport" style="display: inline-block;">
                        <img src="../assets/icons/dianzanred.png"
                             style="width: 11px; height: 11px;min-width:100%; min-height: 100%;transform:rotate(180deg)"/>
                      </div>
                      <div v-if="1>commentItem.unSupport" style="display: inline-block;">
                        <img src="../assets/icons/zanblack.png"
                             style="width: 11px; height: 11px;min-width:100%; min-height: 100%;transform:rotate(180deg)"/>
                      </div>
                      <span style="margin: 3px">{{ commentItem.unSupport }}</span>
                    </span>
              </div>
              <!--            <div>-->
              <!--                <span class="iconfont">&#xe661;</span>-->
              <!--                <span style="margin-left:5px">举报</span>-->
              <!--            </div>-->
            </div>
            <div class="otherComment" v-if="null !=commentItem.reComment">
              <div class="top">
                <img :src="commentItem.reComment.headImg" alt="">
                <div>
                  <div class="name">{{ commentItem.reComment.name }}</div>
                  <span class="date">{{ commentItem.reComment.createTime }}</span>
                </div>
              </div>
              <div class="content">
                {{ commentItem.reComment.comment }}
              </div>
              <div class="otherCount">
                <div class="count">
                    <span @click="addCommentPraise(3)">
                      <div v-if="0 < commentItem.reComment.isSupport" style="display: inline-block;">
                        <img src="../assets/icons/dianzanred.png"
                             style="width: 11px; height: 11px;min-width:100%; min-height: 100%;"/>
                      </div>
                      <div v-if="1>commentItem.reComment.isSupport" style="display: inline-block;">
                        <img src="../assets/icons/zanblack.png"
                             style="width: 11px; height: 11px;min-width:100%; min-height: 100%;"/>
                      </div>
                      <span style="margin: 3px">{{ commentItem.reComment.support }}</span>
                    </span>

                  <span @click="addCommentPraise(4)">
            <div
              v-if="0 < commentItem.reComment.unSupport"
              style="display: inline-block;"
            >
              <img
                src="../assets/icons/dianzanred.png"
                style="width: 11px; height: 11px;min-width:100%; min-height: 100%;transform:rotate(180deg)"
              />
            </div>
            <div
              v-if="1 > commentItem.reComment.unSupport"
              style="display: inline-block;"
            >
              <img
                src="../assets/icons/zanblack.png"
                style="width: 11px; height: 11px;min-width:100%; min-height: 100%;transform:rotate(180deg)"
              />
            </div>
            <span style="margin: 3px">{{
                commentItem.reComment.unSupport
              }}</span>
          </span>
                </div>
                <!--                <div>-->
                <!--                    <span class="iconfont">&#xe661;</span>-->
                <!--                    <span style="margin-left:5px">举报</span>-->
                <!--                </div>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--    登录相关-->
    <el-dialog title="" append-to-body size="medium" :visible.sync="loginWindow" width="900px">
      <Login :isWindow="true" @loginAfter="" ></Login>
    </el-dialog>
    <!--    登录相关-->
  </div>
</template>
<script>
import {addPraise, delPraise} from "@/comm/api";
//登录相关
import Login from "@/views/Login.vue";
import Vue from "vue";
//登录相关

export default {
  components:{
    //登录相关
    Login,
    //登录相关
  },
  data() {
    return {
      //登录相关
      loginWindow: false,
      userId: "",
      //登录相关
    };
  },
  props: {
    commentItem: {
      type: Object,
      default: () => {
        return {

        };
      }
    },
    floor:{
      type: Number,
    },
    createBy: ""
  },
  methods: {
    addCommentPraise(operateType) {
      if(!this.userId){
        this.loginWindow=true;
        return false;
      }
      var param = {};
      param.sourceId = this.commentItem.id;
      param.sourceType = 5;
      param.operateType = operateType;
      param.operatorId = this.userId;
      if (operateType == 1) {
        if (1 > this.commentItem.isSupport) {
          this.commentItem.support++;
          this.commentItem.isSupport = 1;
          addPraise(param);
        } else {
          this.commentItem.support--;
          this.commentItem.isSupport = 0;
          delPraise(param);
        }
      } else if (operateType == 2) {
        param.id = this.commentItem.id;
        if (1 > this.commentItem.isUnSupport) {
          this.commentItem.unSupport++;
          this.commentItem.isUnSupport = 1;
          addPraise(param);
        } else {
          this.commentItem.unSupport--;
          this.commentItem.isUnSupport = 0;
          delPraise(param);
        }
      } else if (operateType == 3) {
        param.id = this.commentItem.reComment.id;
        if (1 > this.commentItem.reComment.isSupport) {
          this.commentItem.reComment.support++;
          this.commentItem.reComment.isSupport = 1;
          addPraise(param);
        } else {
          this.commentItem.reComment.support--;
          this.commentItem.reComment.isSupport = 0;
          delPraise(param);
        }
      } else {
        if (1 > this.commentItem.reComment.isUnSupport) {
          this.commentItem.reComment.unSupport++;
          this.commentItem.reComment.isUnSupport = 1;
          addPraise(param);
        } else {
          this.commentItem.reComment.unSupport--;
          this.commentItem.reComment.isUnSupport = 0;
          delPraise(param);
        }
      }
    }
  },
  created() {
    //登录相关
    let userInfo=Vue.ls.get("UserInfo");
    if(!!userInfo)
      this.userId=userInfo.id;
    //登录相关
  }
};
</script>
<style lang="stylus" scoped>
.ccontainer
  padding 20px 0px;
  background-color white;
  border-bottom 1px solid #f2f2f2;

  .top
    display flex;
    justify-content flex-start;
    align-items center;

    img
      width 32px;
      height 32px;
      border-radius 50px;
      margin-right 10px;

    .name
      font-size: 12px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #363636;
      line-height: 17px;

    .date
      font-size: 8px;
      font-weight: 400;
      color: #999999;
      line-height: 11px;

  .content
    font-size: 14px;
    font-weight: 400;
    color: #363636;
    line-height: 20px;
    margin 17px 0px;

  .otherCount
    font-size: 11px;
    font-weight: 400;
    color: #B8B9BA;
    line-height: 16px;
    display flex;
    justify-content space-between;
    align-items center;

    .count
      span
        margin-right 10px;
        cursor pointer;

  .otherComment
    // width 80%;
    // height 150px
    margin 20px;
    background #F5F5F5;
    border-radius: 4px;
    border: 1px solid #F3F3F5;
    position relative;
    padding 20px;

    &:before {
      position: absolute;
      content: "";
      top: -10px;
      left: 25px;
      // border-left: 16px solid transparent;
      border-right: 30px solid transparent;
      border-bottom: 15px solid #F3F3F5;
      // transform: rotate(-25deg);
    }
</style>
